"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shave = _interopRequireDefault(require("shave"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var showLessTextClassName = 'js-show-less-text';
var jsShaveCharClassName = 'js-shave-char';
var resizeEventName = 'resize';

var ReactTextMoreLess = /*#__PURE__*/function (_Component) {
  _inherits(ReactTextMoreLess, _Component);

  var _super = _createSuper(ReactTextMoreLess);

  function ReactTextMoreLess() {
    var _this;

    _classCallCheck(this, ReactTextMoreLess);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "setRootRef", function (root) {
      _this.root = root;
    });

    _defineProperty(_assertThisInitialized(_this), "setDOM", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          collapsed = _this$props.collapsed,
          showMoreText = _this$props.showMoreText,
          lessHeight = _this$props.lessHeight,
          showMoreElement = _this$props.showMoreElement,
          showLessElement = _this$props.showLessElement;

      if (collapsed) {
        (0, _shave["default"])(_this.root, lessHeight, {
          classname: className,
          character: showMoreText,
          spaces: false
        });

        var shaveChar = _this.root.querySelector(".".concat(jsShaveCharClassName));

        if (shaveChar && showMoreElement) {
          // 如果不需要 ellipse，则没有 `shaveChar`
          (0, _reactDom.render)(showMoreElement, shaveChar);
        }
      } else {
        var hasShowLess = !!_this.root.querySelector(".".concat(showLessTextClassName));

        if (_this.root.offsetHeight > lessHeight && showLessElement && !hasShowLess) {
          // 如果需要收起，则展示文字
          var collapse = document.createElement('span');
          collapse.setAttribute('class', showLessTextClassName);
          (0, _reactDom.render)(showLessElement, collapse);

          _this.root.appendChild(collapse);
        }
      }
    });

    return _this;
  }

  _createClass(ReactTextMoreLess, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener(resizeEventName, this.setDOM);
      this.setDOM();
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      // Reset the DOM before update, this makes React render properly.
      this.resetDOM(prevProps);
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setDOM();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resetDOM(this.props);
      window.removeEventListener(resizeEventName, this.setDOM);
    }
  }, {
    key: "resetDOM",
    value: function resetDOM(prevProps) {
      // clean up everything
      var collapsed = prevProps.collapsed,
          showMoreElement = prevProps.showMoreElement;

      if (collapsed) {
        var shaveChar = this.root.querySelector(".".concat(jsShaveCharClassName));

        if (shaveChar && showMoreElement) {
          (0, _reactDom.unmountComponentAtNode)(shaveChar);
        }

        this.root.innerHTML = this.props.text;
      } else {
        var collapse = this.root.querySelector(".".concat(showLessTextClassName));

        if (collapse) {
          (0, _reactDom.unmountComponentAtNode)(collapse);
          this.root.removeChild(collapse);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          text = _this$props2.text,
          onClick = _this$props2.onClick,
          rootProps = _this$props2.rootProps;
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.setRootRef,
        className: className,
        onClick: onClick
      }, rootProps), text);
    }
  }]);

  return ReactTextMoreLess;
}(_react.Component);

exports["default"] = ReactTextMoreLess;

_defineProperty(ReactTextMoreLess, "propTypes", {
  text: _propTypes["default"].string.isRequired,
  lessHeight: _propTypes["default"].number.isRequired,
  collapsed: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  showMoreText: _propTypes["default"].string,
  showMoreElement: _propTypes["default"].element,
  showLessElement: _propTypes["default"].element,
  onClick: _propTypes["default"].func,
  rootProps: _propTypes["default"].object
});

_defineProperty(ReactTextMoreLess, "defaultProps", {
  collapsed: true,
  className: undefined,
  showMoreText: '...',
  showMoreElement: undefined,
  showLessElement: undefined,
  onClick: function onClick() {},
  rootProps: {}
});